import React from "react";
import {
  AddIconCircel,
  RedDeleteIcon,
  TableEditRedIcon,
} from "../../../assets/images";
import { LeaveAndUpcomingHistoryListType } from "../../../redux/stcoTools/stcoToolsType";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { ApplyLeaveFormType } from "../../../commonTypes/stcoToolsType";

type AppProps = {
  data: [] | LeaveAndUpcomingHistoryListType[];
  handleApplyLeave: (data?: string) => void;
  setIsEdit: React.Dispatch<React.SetStateAction<boolean>>;
  setIsDeleteData: React.Dispatch<React.SetStateAction<any>>;
  handleSingleLeaveApply: (data: string) => void;
  handleDeleteUpcomingLeave: (data?: string) => void;
  setApplyLeaveForm: React.Dispatch<React.SetStateAction<ApplyLeaveFormType>>;
};
const UpcomingLeaves = ({
  data,
  handleApplyLeave,
  setIsEdit,
  handleSingleLeaveApply,
  handleDeleteUpcomingLeave,
  setIsDeleteData,
  setApplyLeaveForm,
}: AppProps) => {
  return (
    <div className="p-3">
      <div
        style={{
          fontSize: "18px",
          fontWeight: 600,
        }}
      >
        Upcoming Leaves & Work From Home
      </div>
      {data?.length ? (
        <>
          {data?.map((el: LeaveAndUpcomingHistoryListType) => {
            const unpaidLeave = el?.details?.find(
              (ele: any) => ele?.leave_type === "Unpaid Leave"
            );
            const casualLeave = el?.details?.find(
              (ele: any) => ele?.leave_type === "Casual Leave"
            );
            const unpaidFullTimeLeave = el?.details?.find(
              (ele: any) => ele?.leave_type === "Unpaid Leave(full time)"
            );

            return (
              <div className="boxs p-3 mt-3 rounded-0">
                <div className="d-flex align-items-center justify-content-between">
                  <div style={{ width: "90%" }}>
                    <div className="d-flex align-items-center">
                      <div
                        className="d-flex align-items-center"
                        style={{ gap: "2.5%", width: "100%" }}
                      >
                        <div style={{ fontSize: "16px", fontWeight: 500 }}>
                          {el?.start_date} to {el?.end_date}
                        </div>
                        <div style={{ fontSize: "16px", fontWeight: 500 }}>
                          ({el?.total_days} days)
                        </div>

                        {el?.leave_type ? (
                          <>
                            <div
                              className={
                                el?.leave_type === "Unpaid Leave"
                                  ? "status-incomplete"
                                  : el?.leave_type === "Full time(Unpaid Leave)"
                                  ? "status-Pending"
                                  : "estimatePurchase"
                              }
                              style={{ fontWeight: 500, borderRadius: "16px" }}
                            >
                              {el?.leave_type === "WFH"
                                ? "WFH"
                                : el?.leave_type === "Unpaid Leave"
                                ? "Unpaid Leave"
                                : el?.leave_type === "Casual Leave"
                                ? "Casual Leave"
                                : el?.leave_type ===
                                  "Casual leave(Unpaid Leave)"
                                ? "Casual Leave"
                                : "Unpaid Leave"}
                            </div>

                            {el?.leave_type ===
                              "Casual leave(Unpaid Leave)" && (
                              <div
                                className={"status-Pending"}
                                style={{
                                  fontWeight: 500,
                                  borderRadius: "16px",
                                }}
                              >
                                Unpaid Leave
                              </div>
                            )}
                          </>
                        ) : (
                          ""
                        )}
                        <div
                          className={
                            el?.request_status === 1
                              ? `status-incomplete`
                              : el?.request_status === 3
                              ? "status-complete"
                              : ""
                          }
                          style={{
                            borderRadius: "16px",
                            color:
                              el?.request_status === 3 ? "#82b01f" : "#f3a119",
                            background:
                              el?.request_status === 3 ? "#e7f0d4" : "#faedd8",
                            fontWeight: 500,
                          }}
                        >
                          {el?.request_status === 1
                            ? "Pending"
                            : el?.request_status === 3
                            ? "Approved"
                            : ""}
                        </div>
                      </div>
                    </div>

                    {el?.reason?.length > 150 ? (
                      <OverlayTrigger
                        placement="bottom"
                        delay={{ show: 250, hide: 250 }}
                        overlay={
                          <Tooltip id="button-view-open-item">
                            {el?.reason}
                          </Tooltip>
                        }
                      >
                        <div className="mt-2" style={{ width: "fit-content" }}>
                          {el?.reason?.substr(0, 150) +
                            (el?.reason && el?.reason?.length > 150
                              ? "..."
                              : "")}
                        </div>
                      </OverlayTrigger>
                    ) : (
                      <div className="mt-2">{el?.reason}</div>
                    )}

                    {/* <div>{el?.reason}</div> */}
                  </div>
                  <div style={{ marginTop: "-30px" }}>
                    <div className="d-flex" style={{ gap: "2%" }}>
                      <div>
                        <OverlayTrigger
                          placement="top"
                          delay={{ show: 250, hide: 250 }}
                          overlay={
                            <Tooltip id="button-view-open-item">Edit</Tooltip>
                          }
                        >
                          <img
                            src={TableEditRedIcon}
                            alt="edit-icon"
                            className="pointer"
                            onClick={() => {
                              handleApplyLeave(
                                el?.type === 2 ? "WFH" : "Leave"
                              );
                              setIsEdit(true);
                              handleSingleLeaveApply(el?._id);

                              setApplyLeaveForm((prv: ApplyLeaveFormType) => {
                                return {
                                  ...prv,
                                  _id: el?._id,
                                };
                              });
                            }}
                          />
                        </OverlayTrigger>
                      </div>
                      <div>
                        <OverlayTrigger
                          placement="top"
                          delay={{ show: 250, hide: 250 }}
                          overlay={
                            <Tooltip id="button-view-open-item">Delete</Tooltip>
                          }
                        >
                          <img
                            src={RedDeleteIcon}
                            alt="delete-icon"
                            className="pointer ml-2"
                            onClick={() => {
                              handleDeleteUpcomingLeave(
                                el?.type === 2 ? "WFH" : "Leave"
                              );
                              setIsDeleteData({
                                start_date: el?.start_date,
                                end_date: el?.end_date,
                                day: el?.total_days,
                                id: el?._id,
                              });
                            }}
                          />
                        </OverlayTrigger>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
          <div></div>
        </>
      ) : (
        <div className="d-flex justify-content-center align-items-center flex-column mt-5">
          <div style={{ margin: "auto" }}>
            <img src={AddIconCircel} alt="add-icon" />
          </div>
          <div className="mt-3" style={{ fontSize: "20px", fontWeight: 600 }}>
            You don’t have any upcoming leaves / WFH scheduled.
          </div>
          {/* <div style={{ fontSize: "17px", fontWeight: 500 }} className="mt-3">
            Click on button below to apply new leave.
          </div>
          <button
            className="btn btn-primary mt-5"
            onClick={() => handleApplyLeave("Leave")}
          >
            Apply Leave
          </button> */}
        </div>
      )}
    </div>
  );
};

export default UpcomingLeaves;
